import React from "react";
import { bool } from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Field, Form, Formik } from "formik";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import { actions as echeckActions, types } from "reducers/echecks";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import useSchema from "hooks/useSchema";
import GridTable from "pages/_components/GridTable/GridTable";
import SerachBeneficiary from "pages/echeck/components/SearchBeneficiary";
import SwitchField from "pages/_components/fields/formik/SwitchField";
import { actions as notificationActions } from "reducers/notification";

const FORM_ID = "echecks.aval";

const SolicitAval = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { beneficiary, echeqsToDoActions } = useSelector((state) => state.echecks);
    const { stringRequired } = useSchema();
    const hasBeneficiary = beneficiary?.reference;

    const initialValues = {
        adress: echeqsToDoActions?.echeq?.adress || "",
        email: echeqsToDoActions?.echeq?.email || "",
        emailText: echeqsToDoActions?.echeq?.emailText || "",
        sendEmail: echeqsToDoActions?.echeq?.hasEmail || false,
    };
    const handleSubmit = (values) => {
        const { email, emailText, sendEmail } = values;
        const avalistaCuit = beneficiary?.document?.split(" ");
        if (avalistaCuit?.length > 0) {
            if (avalistaCuit[1] === echeqsToDoActions?.echeq?.emisor_cuit) {
                dispatch(
                    notificationActions.showNotification(i18n.get("aval.error.emisor"), "error", [
                        "echecks/aval/solicit",
                    ]),
                );
            } else {
                let isEmail;
                let isEmailText;
                if (sendEmail) {
                    isEmail = email;
                    isEmailText = emailText;
                }
                const toDoActions = {
                    ...echeqsToDoActions,
                    echeq: {
                        ...echeqsToDoActions.echeq,
                        adress: values.adress,
                        email: isEmail,
                        emailText: isEmailText,
                        hasEmail: values.sendEmail,
                    },
                };
                dispatch(echeckActions.setEchecksToDoActions(toDoActions));
                dispatch(push("/echecks/aval/solicit/sumary"));
            }
        }
    };

    const emitEcheckValidation = Yup.lazy((values) => {
        let validate = {
            adress: stringRequired,
        };

        if (values.sendEmail) {
            validate = {
                ...validate,
                email: stringRequired.email(i18n.get("administration.users.emailIncorrectFormat")),
            };
        }

        return Yup.object().shape(validate);
    });
    return (
        <>
            <Notification scopeToShow="echecks/aval/solicit" />
            <ResponsiveHeader id="echecks.solicit.aval" />
            <MainContainer>
                <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={emitEcheckValidation}>
                    {({ values }) => (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data columnStart={2} columnWidth={10}>
                                        <SerachBeneficiary
                                            type={types.SELECT_BENEFICIARY}
                                            beneficiary={beneficiary}
                                            echeqsToDoActions={echeqsToDoActions}
                                            caracter={echeqsToDoActions?.echeq?.cheque_caracter}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} columnWidth={5} rowStart={2}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="adress"
                                            disabled={!hasBeneficiary}
                                            type="text"
                                            maxLength="100"
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data
                                        columnStart={7}
                                        columnWidth={5}
                                        rowStart={2}
                                        className="form-group hidden-label">
                                        <Field component={SwitchField} idForm={FORM_ID} name="sendEmail" />
                                    </GridTable.Data>
                                    {values.sendEmail && (
                                        <>
                                            <GridTable.Data columnStart={2} columnWidth={5} rowStart={3}>
                                                <Field
                                                    component={TextField}
                                                    idForm={FORM_ID}
                                                    name="email"
                                                    type="email"
                                                    disabled={!hasBeneficiary}
                                                    hidePlaceholder
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={7} columnWidth={5} rowStart={3}>
                                                <Field
                                                    component={TextField}
                                                    idForm={FORM_ID}
                                                    name="emailText"
                                                    disabled={!hasBeneficiary}
                                                    maxLength="150"
                                                    type="text"
                                                    hidePlaceholder
                                                />
                                            </GridTable.Data>
                                        </>
                                    )}
                                </GridTable.Container>
                            </GridTable>
                            <GridTable>
                                <GridTable.Container columns={12} columnsTemplate="fixed" className="form-actions">
                                    <GridTable.Data columnStart={isDesktop ? 5 : 1} columnWidth={isDesktop ? 4 : 12}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={
                                                values.sendEmail
                                                    ? !values.adress || !hasBeneficiary || !values.email
                                                    : !values.adress || !hasBeneficiary
                                            }
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

SolicitAval.propTypes = {
    isDesktop: bool.isRequired,
};

export default SolicitAval;
